/* eslint-disable space-after-keywords */
define([], () => {
    return [() => {
        return (submissionNoText) => {
            let formatted = submissionNoText;
            if (submissionNoText) {
                if (submissionNoText.length > 2) {
                    formatted = `${submissionNoText.substr(0, 2)}-`;
                }
                formatted += submissionNoText.substr(2).replace(/(?!^)(?=(.{3})+(?=\.|$))/gm, '$&.'); // add a dot every 3 digits
            }
            return formatted;
        };
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/filters/SubmissionNumberFormatter.js